import { Css } from "~generated/css";
import { CheckoutConfigOptionGroupStep } from "~generated/graphqlTypes";
import { SummaryPrintConfiguration_CheckoutConfigFragment } from "../SummaryPrint.page.generated";
import { PDFPage } from "./PDFPage";
import { PrintHeader } from "./PrintHeader";
import { PrintListItem } from "./PrintListItem";

type ExteriorReportProps = {
  data: SummaryPrintConfiguration_CheckoutConfigFragment;
  shouldDisplayPricing: boolean;
};

export function ExteriorReport({ data, shouldDisplayPricing }: ExteriorReportProps) {
  const { optionGroups, rendering, name, customerEmail, createdAt, reservedAt, expiresAt, status } = data ?? {};
  return (
    <PDFPage>
      <div css={Css.relative.h100.w100.bgWhite.$}>
        <div css={Css.df.ma.fdc.gap2.p1.pb4.asc.maxContainer.$}>
          <PrintHeader
            status={status}
            expiredAt={expiresAt}
            createdAt={createdAt}
            reservedAt={reservedAt}
            configurationName={name}
            customerEmail={customerEmail}
          />
          <div css={Css.t16.gray900.fw600.$}>Exterior</div>
          {rendering?.largePreview && <img src={rendering.largePreview} css={Css.w100.ha.$} alt={"exterior"} />}
          <ExteriorPDFCard optionGroups={optionGroups} shouldDisplayPricing={shouldDisplayPricing} />
        </div>
      </div>
    </PDFPage>
  );
}

type ExteriorPDFCardProps = { shouldDisplayPricing: boolean } & Pick<
  SummaryPrintConfiguration_CheckoutConfigFragment,
  "optionGroups"
>;

export function ExteriorPDFCard({ optionGroups, shouldDisplayPricing }: ExteriorPDFCardProps) {
  const exteriorSteps = [
    CheckoutConfigOptionGroupStep.ExteriorElevation,
    CheckoutConfigOptionGroupStep.ExteriorDesignPackage,
  ];
  const exteriorOptions = optionGroups
    .filter((ccog) => exteriorSteps.includes(ccog.step) && !!ccog.selectedOption)
    .map((ccog) => ccog.selectedOption!);
  return (
    <div css={Css.df.fdc.$}>
      <PrintListItem
        shouldDisplayPricing={shouldDisplayPricing}
        title="Exterior"
        priceInCents={exteriorOptions.sum((cco) => cco.totalPriceInCents)}
        items={exteriorOptions.map((cco) => ({
          // Note: we don't show location here because it is implied by being in exterior section.
          title: cco.option.name,
          priceInCents: cco.totalPriceInCents,
          optionCode: cco.option.code,
        }))}
      />
    </div>
  );
}
